exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".footer__link[data-v-14704847]{font-size:14px}.footer__action[data-v-14704847]{display:block;width:100%;margin:24px 0 0;font-size:11px}@media screen and (min-width:390px){.footer__action[data-v-14704847]{font-size:12px}}@media screen and (min-width:500px){.footer__action[data-v-14704847]{max-width:360px}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-14704847","scoped":true,"hasInlineConfig":true}!./node_modules/stylus-loader!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/profile/views/certificate/components/footer/Footer.vue
// module id = bd2e42c507209eee32cb
// module chunks = 9